<template>
    <component :is="tag">
        <template
            v-if="modelValue"
        >
            {{ metric }}
        </template>
        <template
            v-else
        >
            {{ imperial }}
        </template>
    </component>
</template>

<script lang="ts" setup>
    withDefaults(
        defineProps<{
            modelValue: boolean;
            imperial: string;
            metric: string;
            tag?: string;
        }>(),
        {
            tag: 'div'
        }
    );
</script>

<style lang="scss"></style>
